import { render, staticRenderFns } from "./DocumentView.vue?vue&type=template&id=4273b78e&scoped=true"
import script from "./DocumentView.vue?vue&type=script&lang=ts"
export * from "./DocumentView.vue?vue&type=script&lang=ts"
import style0 from "./DocumentView.vue?vue&type=style&index=0&id=4273b78e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4273b78e",
  null
  
)

export default component.exports